  
export default class SortUtils {

  static SortBy_modifiedDateAz = function (a, b) {
    return SortUtils.SortBy("modifiedDate", a, b);
  }

  static SortBy_modifiedDateZa = function (a, b) {
    return SortUtils.SortByDesc("modifiedDate", a, b);
  }

  static SortBy_nameZa = function (a, b) {
    return SortUtils.SortByDesc("name", a, b);
  }

  static SortBy_nameAz = function (a, b) {
    return SortUtils.SortBy("name", a, b);
  }

  static SortBy_createdDateZa = function (a, b) {
    return SortUtils.SortByDesc("createdDate", a, b);
  }

  static SortBy_createdDateAz = function (a, b) {
    return SortUtils.SortBy("createdDate", a, b);
  }

  static SortBy = function(methodName, a, b) {
    if (a == null || b == null) {
      return 0;
    }
    
    let aValue = SortUtils.resultFromFunction(a[methodName]());
    let bValue = SortUtils.resultFromFunction(b[methodName]());

    if (aValue < bValue) {
      return -1;
    }

    if (aValue > bValue) {
      return 1;
    }

    return 0;
  }

  static SortByDesc = function(methodName, a, b) {
    if (a == null || b == null) {
      return 0;
    }

    let aValue = SortUtils.resultFromFunction(a[methodName]());
    let bValue = SortUtils.resultFromFunction(b[methodName]());

    if (aValue < bValue) {
      return 1;
    }

    if (aValue > bValue) {
      return -1;
    }

    return 0;
  }

  static resultFromFunction = function(aFunctionOrValue) {
    if (aFunctionOrValue == null || aFunctionOrValue == undefined) {
      return 0;
    }
    if (typeof aFunction === 'function') {
      return SortUtils.resultFromFunction(aFunctionOrValue());
    }
    if (aFunctionOrValue.time) {
      return aFunctionOrValue.time();
    }
    return aFunctionOrValue
  }
}